import { render, staticRenderFns } from "./classroomIntelligentBody.vue?vue&type=template&id=3d24002d&scoped=true"
import script from "./classroomIntelligentBody.vue?vue&type=script&lang=js"
export * from "./classroomIntelligentBody.vue?vue&type=script&lang=js"
import style0 from "./classroomIntelligentBody.vue?vue&type=style&index=0&id=3d24002d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d24002d",
  null
  
)

export default component.exports